export const CHANGE_TAB = "CHANGE_TAB";

export const changeTab = (id) => {
  return async (dispatch) => {
    dispatch({
      type: CHANGE_TAB,
      payload: id,
    });
  };
};